<template>
  <v-card class="ma-0" width="100%" style="height: auto" elevation="2">
    <v-app-bar flat class="my-0 mb-6 py-1 px-2" dense height="30">
      <v-toolbar-title class="mt-4 me-4">{{ $t(type) }}</v-toolbar-title>
      <div v-if="!isMobile && !isTablet" style="width: 230px">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("remove") }}
        </p>
        <v-icon> mdi-trash-can-outline </v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important; padding: 0 !important"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon> mdi-dots-vertical </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item link @click="openUploadDialog">
            <v-list-item-icon>
              <v-icon>mdi-database-import-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('importData')" />
          </v-list-item>
          <v-list-item
            link
            v-if="lockPermission && selected.length > 0"
            @click="lockGroup('lock')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('lock')" />
          </v-list-item>
          <v-list-item
            v-if="lockPermission && selected.length > 0"
            link
            @click="unlockGroup('unlock')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock-open-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('unlock')" />
          </v-list-item>
          <log
            v-if="
              $store.state.permissions && $store.state.permissions.includes('logList')
            "
            ref="logRef"
            :type-prop="type"
            :listProp="true"
            mode-prop="button"
          />
          <v-list-item v-if="isMobile || isTablet" link @click="getItems">
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item v-if="isMobile || isTablet" link @getAllRows="getAllRows">
            <export-excel
              ref="refExcel"
              :data="excelItems"
              worksheet="abriron.com"
              name="data.xls"
              type="xls"
              class="float-left d-flex"
              :title="$store.state.abrName"
              :total-prop="pageCount"
              :page-prop="excelPage"
              @getAllRows="getAllRows"
            >
              <v-list-item-icon>
                <v-icon>mdi-file-excel-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('excel')" />
            </export-excel>
          </v-list-item>
          <v-list-item v-if="isMobile || isTablet" link @click="printDialog = true">
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
          <v-list-item v-if="isMobile || isTablet" link @click="goTo(type)">
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t(type)" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important; padding: 0 !important"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon> mdi-refresh </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn outlined class="mt-4 ms-2" color="grey darken-2 " height="32">
          <p class="font-weight-thin mb-0 me-2">
            {{ $t("excel") }}
          </p>
          <v-icon> mdi-file-excel-outline </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("filter") }}
        </p>
        <v-icon> mdi-filter-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4 ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("print") }}
        </p>
        <v-icon> mdi-printer-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="goTo(type)"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t(type) }}
        </p>
        <v-icon> mdi-plus </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row v-if="isMobile || isTablet" class="mx-0">
      <v-col class="mb-4 px-2" cols="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-col
      id="print"
      cols="12"
      class="px-2"
      :class="{ 'mt-6': !isMobile && !isTablet, 'mt-0': isMobile || isTablet }"
    >
      <v-data-table
        v-if="headers"
        :height="isMobile || isTablet || mobileShow ? 323 : tableHeight"
        fixed-header
        v-model="selected"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :page.sync="page"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3; border-radius: 6px"
        :footer-props="{
          showFirstLastPage: !mobileShow ? true : false,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus',
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" icon v-on="on">
                <v-icon medium> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item link :disabled="item.lock ? true : false" @click="edit(item)">
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-if="lockPermission"
                link
                @click="lock(item, item.lock ? 'unlock' : 'lock')"
              >
                <v-list-item-icon>
                  <v-icon :color="item.lock ? 'green' : 'pink'">{{
                    item.lock ? "mdi-lock-open-outline" : "mdi-lock-outline"
                  }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="item.lock ? $t('unlock') : $t('lock')" />
              </v-list-item>
              <!--add excel for each item -->
              <v-list-item
                v-show="$route.name === 'warehouseHandlingList'"
                link
                @click.stop="exportRowExcel(item)"
              >
                <v-list-item-icon>
                  <v-icon color="teal">mdi-file-excel-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('get-excel')" />
              </v-list-item>
              <v-list-item link @click="print(item)">
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print')" />
              </v-list-item>
              <v-list-item
                v-if="
                  (type === 'remittance' ||
                    type === 'receipt' ||
                    type === 'tempReceipt') &&
                  (!item.status || (item.status && $store.state.admin))
                "
                link
                @click="checkout(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-tag-check</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t(type + 'Checkout')" />
              </v-list-item>
              <v-list-item link @click="copyToInvoice(item)">
                <v-list-item-icon>
                  <v-icon>mdi-content-copy</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copyToInvoice')" />
              </v-list-item>
              <v-list-item
                link
                v-clipboard:copy="$baseURL + '/entrepot/' + type + '/print/' + item.id"
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="type"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                v-show="removePermission(type)"
                link
                :disabled="item.lock ? true : false"
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                {{ item.user.firstname }} {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.amount="{ item }">
          {{ $numberFormat(item.amount) }} {{ item.currency.name }}
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
          <v-icon v-if="item.lock" color="red" style="font-size: 22px">
            mdi-lock-outline
          </v-icon>
        </template>
        <template v-slot:item.row="{ item }">
          <a @click="edit(item)">
            {{ parseInt(items.indexOf(item)) + parseInt(from) }}
          </a>
        </template>
        <template v-slot:item.type="{ item }">
          {{ item.type ? $t(item.type) : "" }}
        </template>
        <template v-slot:item.recipient_entrepot.name="{ item }">
          {{ item.recipient_entrepot ? item.recipient_entrepot.name : "ندارد" }}
        </template>
        <template v-slot:item.recipientBranch.name="{ item }">
          {{ item.recipientBranch ? item.recipientBranch.name : "ندارد" }}
        </template>
        <template v-slot:item.branch.name="{ item }">
          {{ item.branch ? item.branch.name : "ندارد" }}
        </template>
        <template v-slot:item.tags="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(tag, index) in item.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.invoice="{ item }">
          <div class="pt-1">
            <v-chip
              v-if="item.invoice"
              :color="item.invoice.color"
              label
              outlined
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              {{ item.invoice.name }}
            </v-chip>
          </div>
        </template>
        <template v-slot:item.last_status.status_id="{ item }">
          <v-chip
            v-if="item.last_status && item.last_status.status"
            :color="item.last_status.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1"
          >
            <span class="px-2 white--text">
              {{ item.last_status.status.name }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            v-if="item.status"
            label
            small
            :color="item.status === 'storekeeperCountError' ? 'pOrrange' : 'primary'"
            style="margin-left: 1px; margin-right: 1px"
            class="px-1 mb-1"
          >
            <span class="px-1 white--text">
              {{ $t(item.status) }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.content="{ item }">
          {{ item.content ? item.content : "ندارد" }}
        </template>
        <template v-slot:footer.prepend>
          <v-col v-show="!isMobile" cols="1" class="pa-0" style="margin-top: -10px">
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <!--    filter dialog-->
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="filter = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("filter") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" md="4">
            <autocomplete
              v-model="product"
              type="product"
              :title="$t('product')"
              :outlined="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="entrepot"
              title="entrepot"
              type="entrepot"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <status v-model="sellStatus" :hideconfig="true" />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <tag v-model="tag" />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="lockStatus"
              :label="$t('lockStatusDocuments')"
              :items="lockStatusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="statusControll"
              :label="$t('statusControll')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromTime"
                v-model="fromTime"
                :label="$t('from-hour')"
                outlined
                dense
                clearable
                readonly
              />
              <date-picker
                v-model="fromTime"
                element="fromTime"
                type="time"
                :locale="$store.state.date_locale"
                :format="'HH:mm'"
                :display-format="'HH'"
                auto-submit
                :color="
                  $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toTime"
                v-model="toTime"
                :label="$t('to-hour')"
                outlined
                dense
                clearable
                readonly
              />
              <date-picker
                v-model="toTime"
                element="toTime"
                type="time"
                :locale="$store.state.date_locale"
                :format="'HH:mm'"
                :display-format="'HH'"
                auto-submit
                :color="
                  $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn class="mx-0" color="primary" @click="getItems">
                {{ $t("filter") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    tasl dialog-->
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    delete dialog-->
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    print dialog-->
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print :headerProp="headers_v" :itemsProp="items" :title="$t('cashPayList')" />
        </v-row>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload doalog-->
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            :type-prop="type === 'warehouseHandling' ? 'warehouseHandling' : 'entrepot'"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <export-excel
      v-show="false"
      ref="rowExcelRef"
      :data="rowExcelItems"
      worksheet="abriron.com"
      :name="rowExcelFileName"
      type="xls"
      :title="$store.state.abrName"
      :total-prop="1"
      :page-prop="1"
      :excelIndex="true"
    />
    <snakbar v-model="snakbar" :text="snakbarText" :active="snakbar" />
  </v-card>
</template>

<script>
import Task from "../task/task";
import General from "../../../../Mixins/general";
import Print from "../../components/general/Print/Index";
import Upload from "../../components/general/upload/upload";
export default {
  name: "entrepotList",
  components: {
    Snakbar: () => import("../../components/general/snakbar/snakbar"),
    Tag: () => import("../../components/general/Tag/tag"),
    Status: () => import("../../components/general/Status/status"),
    Upload,
    Task,
    Print,
  },
  mixins: [General],
  props: ["input", "refId", "mobileShow"],
  data: () => ({
    excelItems: [],
    rowExcelItems: [],
    rowExcelFileName: "entrepot-data.xls",
    statusItems: [],
    selected: [],
    pageCount: 1,
    page: 1,
    printDialog: false,
    deletDialog: false,
    uploadDialog: false,
    filter: false,
    product: null,
    entrepot: null,
    statusControll: null,
    model: null,
    from: 1,
    taskDialog: null,
    type: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    taskId: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    search: null,
    fromTime: null,
    toTime: null,
    printItems: [],
    printType: "entrepot",
  }),
  computed: {
    showSelect() {
      if (!this.isMobile) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      this.model = this.selected[0].text;
      this.temp = this.selected[0].text;
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
  },
  beforeMount() {
    this.type = this.$route.name;
    if (this.$route.name === "tempReceiptList") {
      this.type = "tempReceipt";
    }
    if (this.$route.name === "receiptList") {
      this.type = "receipt";
    }
    if (this.$route.name === "remittanceList") {
      this.type = "remittance";
    }
    if (this.$route.name === "useRemittanceList") {
      this.type = "useRemittance";
    }
    if (this.$route.name === "transferRemittanceList") {
      this.type = "transferRemittance";
    }
    if (this.$route.name === "warehouseHandlingList") {
      this.type = "warehouseHandling";
    }
    if (this.$route.name === "transferProductStockList") {
      this.type = "transferProductStock";
    }
    this.headers = [
      {
        text: this.$t("actions"),
        align: "start",
        sortable: false,
        value: "actions",
        width: 20,
      },
      {
        text: this.$t("row"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("id"),
        sortable: false,
        value: "id",
      },
      {
        text: this.$t("document-number"),
        sortable: true,
        value: "doc_header.number",
      },
      //condition for show these column
      ...(this.$route.name === "transferRemittanceList"
        ? [
            {
              text: this.$t("type"),
              sortable: false,
              value: "type",
            },
          ]
        : []),
      {
        text: this.$t("entrepot"),
        sortable: false,
        value: "entrepot.name",
      },
      {
        text: this.$t("branch"),
        sortable: false,
        value: "branch.name",
      },
      //condition for show these column
      ...(this.$route.name === "transferRemittanceList"
        ? [
            {
              text: this.$t("recipientEntrepot"),
              sortable: false,
              value: "recipient_entrepot.name",
            },
            {
              text: this.$t("recipientBranch"),
              sortable: false,
              value: "recipientBranch.name",
            },
          ]
        : []),
      {
        text: this.$t("date"),
        sortable: true,
        value: "date",
        table: "entrepot_head.date",
      },
      {
        text: this.$t("statusControll"),
        sortable: true,
        value: "status",
        table: "entrepot_head.status",
      },
      {
        text: this.$t("relation-whit"),
        sortable: false,
        value: "invoice",
      },
      {
        text: this.$t("status"),
        sortable: true,
        value: "last_status.status_id",
        width: 50,
      },
      {
        text: this.$t("tag"),
        sortable: false,
        value: "tags",
      },
      {
        text: this.$t("description"),
        sortable: true,
        value: "content",
        table: "payments.content",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
    ];
    this.headers_v = [
      // {
      //   text: this.$t("actions"),
      //   align: "start",
      //   sortable: false,
      //   value: "actions",
      //   width: 20,
      // },
      {
        text: this.$t("row"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("id"),
        sortable: false,
        value: "id",
      },
      {
        text: this.$t("document-number"),
        sortable: true,
        value: "doc_header.number",
      },
      {
        text: this.$t("entrepot"),
        sortable: false,
        value: "entrepot.name",
      },
      {
        text: this.$t("recipientEntrepot"),
        sortable: false,
        value: "recipient_entrepot.name",
      },
      {
        text: this.$t("date"),
        sortable: true,
        value: "date",
        table: "entrepot_head.date",
      },
      // {
      //   text: this.$t("statusControll"),
      //   sortable: true,
      //   value: "status",
      //   table: "entrepot_head.status",
      // },
      {
        text: this.$t("branch"),
        sortable: false,
        value: "branch.name",
      },
      // {
      //   text: this.$t("relation-whit"),
      //   sortable: false,
      //   value: "invoice",
      // },
      // {
      //   text: this.$t("status"),
      //   sortable: true,
      //   value: "last_status.status_id",
      //   width: 50,
      // },
      // {
      //   text: this.$t("tag"),
      //   sortable: false,
      //   value: "tags",
      // },
      {
        text: this.$t("description"),
        sortable: true,
        value: "content",
        table: "payments.content",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
    ];
    this.statusItems = [
      {
        value: "LeavingTheWarehouse",
        text: this.$t("LeavingTheWarehouse"),
      },
      {
        value: "LogInWarehouse",
        text: this.$t("LogInWarehouse"),
      },
      {
        value: "storekeeperCountError",
        text: this.$t("storekeeperCountError"),
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
  },
  mounted() {
    // this.getItems()
  },
  methods: {
    printExecution(id) {
      var app = this;
      app.printItems.push(id);

      app.loading = true;
      app.$axios
        .get(app.$endpoint + "entrepot", {
          params: {
            print: "active",
            id: app.printItems,
            type: app.printType,
          },
        })
        .then((res) => {
          res = res.data;
          app.$router.push({
            name: "reportViewer",
            params: { dataProp: res, reportProp: app.printType },
          });
          app.printItems = [];
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    lock(item, type) {
      if (this.$store.state.userCurrentPlan != null) {
        const lockItem = this.$store.state.userCurrentPlan.plan.options.find(
          (item) => item.key == "lockSystem"
        );
        if (lockItem && lockItem.value == "deactive") {
          this.$store.commit("SET_PLAN_DIALOG", true);
          this.$router.replace("/");
        } else {
          this.selected = [item];
          this.lockGroup(type);
        }
      }
    },
    // add unlock group send type
    unlockGroup(type = "unlock") {
      this.lockGroup(type);
    },
    lockGroup(type) {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "entrepot", {
          params: {
            lock: "active",
            id: selected,
            type: type,
          },
        })
        .then((res) => {
          res = res.data;
          app.snakbarText = this.$t("opertationSuccess");
          app.snakbarColor = "green";
          app.snakbar = true;
          app.getItems();
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.loading = false;
          app.selected = [];
        });
    },
    openUploadDialog(item) {
      this.uploadDialog = true;
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      if (item.lock) {
        return false;
      }
      this.$router.push({ name: this.type + "Edit", params: { id: item.id } });
    },
    checkout(item) {
      if (item.lock) {
        return false;
      }
      this.$router.push({ name: this.type + "Checkout", params: { id: item.id } });
    },
    print(item) {
      this.$router.push({ name: this.type + "Print", params: { id: item.id } });
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.filter = false;
      app.$axios
        .get(this.$endpoint + "entrepot", {
          params: {
            search: app.search,
            lockStatus: app.lockStatus,
            page: app.allRows ? app.excelPage : app.options.page,
            product: app.product,
            entrepot: app.entrepot,
            refId: app.refId,
            branch: app.branch,
            type: app.type,
            sortBy: app.sortBy,
            options: app.options,
            tag: app.tag,
            status: app.sellStatus,
            statusControll: app.statusControll,
            fromTime: app.fromTime,
            toTime: app.toTime,
          },
        })
        .then((res) => {
          res = res.data;
          if (!app.allRows) {
            app.items = res.data;
            app.totalItems = res.total;
            app.pageCount = res.last_page;
            app.from = res.from;
            app.creatExcelData(res.data);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
        })
        .catch((err) => {
          var error = err.response;
          if (error.status === 401) {
            this.$router.push({ name: "logout" });
          }
        })
        .finally(() => (app.loading = false));
    },
    copyToInvoice(item) {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "entrepot/" + item.id + "/edit", {
          params: {
            id: item.id,
          },
        })
        .then((res) => {
          res = res.data;
          var items = [];
          res.articles.map(function (value) {
            items.push({
              product: value.product,
              count: value.count,
              countEdit: 0,
              fee: null,
              discount: 0,
              discountPercent: 0,
              tax: 0,
              unit: null,
              content: 0,
            });
          });
          app.$router.push({ name: "sell", params: { itemsProp: items } });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "entrepot/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .finally(() => (app.loading = false));
    },
    removegroup() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push({ id: value.id });
      });
      app.$axios
        .get(this.$endpoint + "entrepot", {
          params: {
            deleteItems: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .finally(() => (app.loading = false));
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        app.excelItems.push({
          id: d.id,
          date: d.date,
          type: app.$t(d.type),
          entrepot: d.entrepot ? d.entrepot.name : "",
          docHeader: d.doc_header ? d.doc_header.number : "",
          invoice: d.invoice ? d.invoice.type + " | " + d.invoice.id : "",
          user: d.user ? d.user.name : "",
        });
      });
    },
    //create excel for each item
    exportRowExcel(item) {
      var app = this;
      app.rowExcelFileName = "entrepot-" + item.id + ".xls";
      app.loading = true;
      app.$axios
        .get(app.$endpoint + "entrepot/" + item.id + "/edit", {
          params: {
            id: item.id,
          },
        })
        .then((res) => {
          app.creatArticlesExcelData(res.data.articles);
          app.$nextTick(() => {
            if (app.rowExcelItems.length && app.$refs.rowExcelRef) {
              app.$refs.rowExcelRef.generate();
            }
          });
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
        });
    },
    creatArticlesExcelData(data) {
      var app = this;
      app.rowExcelItems = [];
      data.map(function (d) {
        app.rowExcelItems.push({
          id: d.id,
          productName: d.product.name,
          stock:
            d.product && d.product.stock
              ? app.$numberFormat(d.product.stock.count, 3)
              : 0,
          counting_one: d.counting_one ? d.counting_one : "",
          counting_two: d.counting_two ? d.counting_two : "",
          counting_final: d.count ? d.count : "",
          Stock_shortage_or_excess_in_warehouse: app.resolveWarehouseStock(d),
          price: d.price ? app.$numberFormat(d.price) : "",
          expireDate: d.expire_date ? d.expire_date : "",
          content: d.content ? d.content : "",
          entrepot: d.entrepot ? d.entrepot.name : "",
        });
      });
    },
    resolveWarehouseStock(item) {
      if (item.product.stock.count) {
        if (item.count != null) {
          return Number(item.product.stock.count) - Number(item.count);
        } else if (item.counting_two != null) {
          return Number(item.product.stock.count) - Number(item.counting_two);
        } else if (item.counting_one != null) {
          return Number(item.product.stock.count) - Number(item.counting_one);
        }
      } else {
        return Number(item.product.stock.count);
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
</style>
